import { render } from "./DaysView.vue?vue&type=template&id=84aa1c40"
import script from "./DaysView.vue?vue&type=script&lang=js"
export * from "./DaysView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__